import React from 'react';
import ReactDOM from 'react-dom';

import isUrl from 'is-url';

import Button from './styled/Button';
import Icon from './styled/Icon';
import StyledMenu from './styled/StyledMenu';
import StyledInput from './styled/StyledInput';

const defaultLinkState = {
  linkPrompt: false,
  linkError: false,
  linkValue: null,
  linkSelectionValue: null,
};

class MarkMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = defaultLinkState;

    this.onClickMark = this.onClickMark.bind(this);
    this.onEnterLink = this.onEnterLink.bind(this);
    this.promptForLink = this.promptForLink.bind(this);
    this.resetLink = this.resetLink.bind(this);
  }

  render() {
    const { className, innerRef } = this.props;
    const root = window.document.getElementsByTagName('body')[0] || document.root;

    const linkOption = this.hasLink() ?
      this.renderMarkButton('unlink', 'fas fa-unlink') :
      this.renderMarkButton('link', 'fas fa-link');

    const options = !this.state.linkPrompt ?
      [
        this.renderMarkButton('bold', 'fas fa-bold'),
        this.renderMarkButton('italic', 'fas fa-italic'),
        this.renderMarkButton('small', 'fas fa-font fa-xs'),
        linkOption,
      ] : (
        <StyledInput
          type='url'
          innerRef={(input) => { this.urlInput = input; }}
          placeholder='Enter a URL...'
          invalid={this.state.linkError}
          value={this.state.linkValue}
          onChange={({ target }) => {
            this.setState({ linkValue: target.value });
          }}
          onKeyPress={({ key, target }) => {
            if (key === 'Enter') {
              if (!isUrl(target.value)) {
                this.setState({ linkError: true });
              } else {
                this.onEnterLink(target.value);
              }
            }
          }}
          onKeyDown={({ key }) => {
            if (key === 'Escape') this.resetLink();
          }}
          onBlur={this.resetLink}
          autoFocus
        />
      );

    return ReactDOM.createPortal(
      <StyledMenu className={className} innerRef={innerRef}>
        {options}
      </StyledMenu>,
      root
    );
  }

  hasBlock(type) {
    const { value } = this.props;
    return value.blocks.some(node => node.type === type);
  }

  hasLink() {
    const { value } = this.props;
    return value.inlines.some(inline => inline.type === 'link');
  }

  renderMarkButton(type, icon) {
    const { value } = this.props;
    const isActive = value.activeMarks.some(mark => mark.type === type);
    return (
      <Button
        reversed
        active={isActive}
        onMouseDown={event => this.onClickMark(event, type)}
      >
        <Icon className={icon} />
      </Button>
    );
  }

  onClickMark(event, type) {
    const { value, onChange } = this.props;
    event.preventDefault();
    let change;
    switch (type) {
      case 'unlink':
        change = value.change().unwrapInline('link');
        onChange(change);
        break;
      case 'link':
        this.promptForLink(value);
        break;
      default:
        change = value.change().toggleMark(type);
        onChange(change);
        break;
    }
  }

  promptForLink(value) {
    this.setState({
      linkPrompt: true,
      linkSelectionValue: value,
    });
  }

  onEnterLink(href) {
    const { onChange } = this.props;
    const value = this.state.linkSelectionValue;
    const change = value.change().wrapInline({
      type: 'link',
      data: { href },
    }).collapseToEnd();
    onChange(change);
    this.resetLink();
  }

  resetLink() {
    this.setState(defaultLinkState);
  }
}

export default MarkMenu;
